module.exports = __webpack_public_path__ + "img/lang-32.9559493c.jpg";